import React from "react";

export const Footer = () => {
  return (
    <div className="footer-container">
      <small>
        Copyright &copy; 2025 Virtus solutions d.o.o. - podrška
        obrazovanju. Sva prava zadržana{" "}
      </small>
    </div>
  );
};

export default Footer;
